import React from "react";
import style from "./style.scss";

export const RiskContextList = ({ children }) => {
    return <div className={style.base}>{children}</div>;
};
